import { LegalAgreementForm } from '../component/legal-agreement/legal-agreement-form'
import React from 'react'

export const LegalAgreementScreen = (): React.ReactElement => {
  return (
    <div className="floating-form">
      <LegalAgreementForm />
    </div>
  )
}
